'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var RadioButton = function (_Component) {
  (0, _inherits3.default)(RadioButton, _Component);

  function RadioButton() {
    (0, _classCallCheck3.default)(this, RadioButton);
    return (0, _possibleConstructorReturn3.default)(this, (RadioButton.__proto__ || (0, _getPrototypeOf2.default)(RadioButton)).apply(this, arguments));
  }

  (0, _createClass3.default)(RadioButton, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.hasOwnProperty('defaultChecked')) {
        console.warn('[RadioButton]', 'Property defaultChecked is deprecated. Use a controlled component with the checked property instead.');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement('label', {
        className: this.classes
      }, _react2.default.createElement('input', {
        type: 'radio',
        name: this.props.name,
        value: this.props.value,
        checked: this.props.checked,
        onChange: this.props.onChange
      }), _react2.default.createElement('div', {
        className: 'Input-icon'
      }, _react2.default.createElement('i', {
        className: 'material-icons Input-icon-unchecked'
      }, 'radio_button_unchecked'), _react2.default.createElement('i', {
        className: 'material-icons Input-icon-checked'
      }, 'radio_button_checked')), _react2.default.createElement('div', {
        className: 'Input-content'
      }, _react2.default.createElement('div', {
        className: 'Input-text'
      }, _react2.default.createElement('span', {
        className: 'Input-text-main'
      }, this.props.title), this.props.text && _react2.default.createElement('span', {
        className: 'Input-text-help'
      }, this.props.text)), this.props.secondaryTitle && _react2.default.createElement('div', {
        className: 'Input-secondaryTitle'
      }, this.props.secondaryTitle)));
    }
  }, {
    key: 'classes',
    get: function get() {
      var className = 'Input Input--radio ' + this.props.className;

      if (this.props.checked) {
        className += ' is-checked';
      }

      return className;
    }
  }]);
  return RadioButton;
}(_react.Component);

RadioButton.propTypes = {
  checked: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  defaultChecked: _propTypes2.default.bool,
  name: _propTypes2.default.string.isRequired,
  onChange: _propTypes2.default.func,
  secondaryTitle: _propTypes2.default.string,
  text: _propTypes2.default.string,
  title: _propTypes2.default.string.isRequired,
  value: _propTypes2.default.any.isRequired
};
RadioButton.defaultProps = {
  checked: false,
  className: '',
  name: '',
  onChange: function onChange() {},
  secondaryTitle: '',
  text: '',
  title: '',
  value: ''
};
exports.default = RadioButton;